export const unitOverviewBullets = [
  {
    name: "Key concepts and activities",
    description:
      "You can access lists of key concepts and key activities, arranged in bullet points for easy reading.",
  },
  {
    name: "Individual lesson plans",
    description:
      "In the middle of the page, you'll see the full catalogue of lessons. Just click on the lesson you want and it will open the lesson page.",
  },
  {
    name: "Learning outcomes and curriculum",
    description:
      'To access the learning outcomes and curriculum information, just scroll to the bottom of the page. Alternatively, you can access the same learning outcomes and curriculum information by clicking on the curriculum links labelled "science" and "mathematics" in the right side menu.',
  },
  {
    name: "Download unit plans",
    description: `You may notice, in the right side menu, an orange text box titled "Download Unit Plan". By clicking this, you'll download a PDF of that Unit that outlines the purpose, unit overview, the lessons within the unit ,Australian Curriculum links, and other helpful material.`,
  },
  {
    name: "Access the Knowledge Bank",
    description:
      "To access the Knowledge Bank, click on  the coloured links in the right side menu.  You'll see a drop down menu with links to materials designed to aid your teaching on this particular lesson. You can choose an overview or a variety of subtopics. Alternatively, on the top page menu, you'll find the Knowledge Bank link. By clicking on it, you'll open the fullKnowledge Bank and can select a topic of your choice.",
  },
];



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/UnitOverview/TTHTUnitOverviewSection.consts.js